import { StateCreator } from 'zustand';
import { CedarStore } from './types';
import React from 'react';

export const DEFAULT_COLOR = '#FFBFE9';

// Define the styling config interface
export interface StylingConfig {
	color: string; // Color name for the UI elements
	textColor?: string; // Text color for UI elements
	tooltipStyle?: 'solid' | 'lined'; // Style used for tooltips
	iconComponent?: React.ReactNode; // Custom icon component for DialogueBox
	tooltipSize?: 'xs' | 'sm' | 'base' | 'lg' | 'xl' | '2xl'; // Font size for tooltip text
}

// Define the styling slice
export interface StylingSlice {
	styling: StylingConfig;
	setStyling: (styling: Partial<StylingConfig>) => void;
}

// Create the styling slice implementation
export const createStylingSlice: StateCreator<
	CedarStore,
	[],
	[],
	StylingSlice
> = (set) => ({
	// Default styling
	styling: {
		color: '',
		iconComponent: null,
		tooltipSize: 'sm',
	},

	// Actions
	setStyling: (newStyling: Partial<StylingConfig>) =>
		set((state) => ({
			styling: { ...state.styling, ...newStyling },
		})),
});
